<div class="bg-grey-dsk py-5" *ngIf="data.event_loader_show_calendar || !data.event_loader_show_filters">
  <div class="container">
    <h2 class="mb-4">{{ data.event_loader_title ?? "" }}</h2>
    <div class="row g-4">
      <div class="col-lg-6 col-xl-4" *ngFor="let event of data.event_loader_events">
        <!--start card-->
        <div class="card-wrapper border border-light rounded shadow-sm">
          <div class="card no-after rounded">
            <div class="img-responsive-wrapper" *ngIf="event?.field_image?.field_media_image?.uri?.url">
              <div class="img-responsive img-responsive-panoramic">
                <figure class="img-wrapper">
                  <img loading="lazy" [src]="
                      event?.field_image?.field_media_image?.uri?.url
                        ? getthumbnail(event?.field_image?.field_media_image?.uri?.url,'hero'
                          )
                        : ''
                    " [title]="event?.field_image?.field_media_image.meta?.alt"
                    [alt]="event?.field_image?.field_media_image.meta?.alt" />
                </figure>
                <div class="card-calendar d-flex flex-column justify-content-center"
                  *ngIf="event?.event_date[event.event_date.length - 1] || event?.event_date.length">
                  <span class="card-date">
                    <small *ngIf=" event.event_date[event.event_date.length - 1]">dal </small>{{
                    event?.event_date[0]?.value | date : "d"
                    }}</span>
                  <span class="card-day">{{
                    event?.event_date[0]?.value | date : "MMMM"
                    }}</span>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="category-top">
                <span class="category text-decoration-none">{{
                  event.event_type?.name
                  }}</span>
              </div>
              <h3 class="card-title">
                <a [href]="event.path?.alias" class="text-decoration-none">{{
                  event.title
                  }}</a>
              </h3>
              <p class="card-text text-secondary">
                {{ event.event_short_description }}
              </p>
              <blockquote class="card-text mb-5 shadow-sm" *ngIf="event.field_text_date">
                <p class="mb-0">{{ event.field_text_date }}</p>
              </blockquote>
              <a class="read-more t-primary text-uppercase" [href]="event?.path?.alias"
                aria-label="Leggi di più sulla pagina">
                <span class="text">Leggi di più</span>
                <span class="visually-hidden">Legi di piu</span>
                <svg class="icon icon-inverse icon-xs ml-10" aria-label="Leggi di più sulla pagina">
                  <use href="bootstrap-italia/dist/svg/sprites.svg#it-arrow-right"></use>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-xl-4" *ngIf="data?.event_loader_show_calendar">
        <app-calendar (dateClicked)="onDateClicked($event)"></app-calendar>
      </div>
      <!--end card-->
      <div class="d-flex justify-content-end" *ngIf="data.event_loader_anchor_link?.alias">
        <a href="" (click)="onLinkClick($event)" class="btn btn-outline-primary full-mb"
          data-element="live-button-events">
          {{ data.event_loader_anchor_link?.title }}
          <svg class="icon icon-primary icon-xs ml-10" [attr.aria-label]="data.event_loader_anchor_link?.title">
            <use href="bootstrap-italia/dist/svg/sprites.svg#it-arrow-right"></use>
          </svg>
        </a>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="isFilterPage || data.event_loader_show_filters">
  <div class="container mb-5">
    <div class="row justify-content-cente row-shadow rounded">
      <div class="d-flex flex-wrap card card-teaser rounded primary-bg">
        <div class="p-2 bd-highlight col-4">
          <input type="search" placeholder="Cerca per parola chiave" class="rounded" [(ngModel)]="inputText"
            (keydown)="onEnterPressed($event)" />
        </div>
        <div class="p-2 bd-highlight">
          <div class="select-wrapper">
            <label for="catSelect"></label>
            <select id="catSelect" class="rounded" style="max-width: 200px">
              <option selected="" value="">Tutte le categorie</option>
              <ng-container *ngFor="let category of filterCategoryOptions">
                <option [value]="category.value" ngDefaultControl style="font-size: medium">
                  {{ category.name }}
                </option>
              </ng-container>
            </select>
          </div>
        </div>
        <div class="p-2 bd-highlight">
          <p class="text-white mt-2">Da:</p>
        </div>
        <div class="p-2 bd-highlight">
          <input type="date" id="startDate" class="rounded" required [(ngModel)]="startDate" />
        </div>
        <div class="p-2 bd-highlight align-content-around">
          <p class="text-white mt-2">A:</p>
        </div>
        <div class="p-2 bd-highlight">
          <input type="date" id="endDate" class="rounded" required [(ngModel)]="endDate" />
        </div>
        <div class="ms-auto p-2 bd-highlight">
          <button class="btn btn-white btn-m btn-icon" (click)="filterData(inputText, startDate, endDate)">
            <span class="rounded-icon">
              <svg class="icon icon-red" aria-hidden="true" aria-label="Cerca nel sito">
                <use href="bootstrap-italia/dist/svg/sprites.svg#it-search"></use>
              </svg>
            </span>
            <span>Cerca</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="px-4 container mb-5">
    <div class="row" *ngIf="isLoading">
      <div class="progress progress-indeterminate">
        <span class="visually-hidden">In elaborazione...</span>
        <div class="progress-bar" role="progressbar"></div>
      </div>
    </div>
    <div class="row" *ngIf="!isLoading">
      <ng-container *ngFor="let ev of allEvents">
        <div class="col-item mb-3 col-lg-4 col-xl-4">
          <div class="card-wrapper">
            <div class="listing-item card-bg card">
              <div class="img-responsive-wrapper" *ngIf="ev?.field_image?.field_media_image?.uri?.url">
                <div class="img-responsive img-responsive-panoramic">
                  <figure class="img-wrapper">
                    <img loading="lazy" [src]="
                        ev?.field_image?.field_media_image?.uri?.url
                          ? getthumbnail(
                              ev?.field_image?.field_media_image?.uri?.url,'hero'
                            )
                          : ''
                      " [title]="ev?.field_image?.field_media_image.meta?.alt"
                      [alt]="ev?.field_image?.field_media_image.meta?.alt" />
                  </figure>
                  <div class="card-calendar d-flex flex-column justify-content-center"
                    *ngIf="ev?.event_date[ev.event_date.length - 1] || ev?.event_date.length">
                    <span class="card-date">
                      <small *ngIf=" ev.event_date[ev.event_date.length - 1]">dal </small>{{
                      ev?.event_date[0]?.value | date : "d"
                      }}</span>
                    <span class="card-day">{{
                      ev?.event_date[0]?.value | date : "MMMM"
                      }}</span>
                  </div>
                </div>
              </div>
              <div class="px-4 card-body">
                <div class="category-top">
                  <span class="category text-decoration-none">{{
                    ev.event_type.name
                    }}</span>
                  <!-- <span class="data">18 MAG 2018</span> -->
                </div>
                <h3 class="card-title">
                  <a [href]="ev?.path?.alias">{{ ev.title }}</a>
                </h3>
                <p class="mb-3 card-text">{{ ev.event_short_description }}</p>
                <blockquote class="card-text mb-5 shadow-sm" *ngIf="ev.field_text_date">
                  <p class="mb-0">{{ ev.field_text_date }}</p>
                </blockquote>
                <a class="read-more t-primary text-uppercase" [href]="ev?.path?.alias"
                  aria-label="Leggi di più sulla pagina">
                  <span class="text">Leggi di più</span>
                  <span class="visually-hidden">Legi di piu</span>
                  <svg class="icon icon-inverse icon-xs ml-10" aria-label="Leggi di più sulla pagina">
                    <use href="bootstrap-italia/dist/svg/sprites.svg#it-arrow-right"></use>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div *ngIf="!allEvents.length && !isLoading">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
          <div class="alert alert-info" role="alert">
            <p class="mb-0">Nessun evento trovato.</p>
            <p class="mb-0">Prova a modificare i filtri di ricerca.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>